
import { SpeedTestingKey } from '../../types';

export const speedTesting: Record<SpeedTestingKey, string> = {
  speedTestingManual: "Manual",
  speedTestingAutomatic: "Automatic",
  speedTestingActivate: "Activate",
  speedTestingSave: "Save Test",
  speedTestingMyTests: "My Tests",
  speedTestingNoData: "No automatic speed tests exist",
  speedTestingTooltip: "How does speed testing work?",
  speedTestingTooltipText: "Speed tests allow you to A/B test different playback speeds to find the optimal setting for engagement and conversions.",
  speedTestingVelocity: "Speed",
  speedTestingDate: "Date",
  speedTestingViews: "Views",
  speedTestingConversions: "Conversions",
  speedTestingConversionRate: "Conversion Rate",
  speedTestingEngagement: "Engagement",
  speedTestingPlays: "Plays",
  speedTestingPlayRate: "Play Rate",
  speedTestingClicks: "Clicks",
  speedTestingUniqueViews: "Unique Views",
  speedTestingUniquePlays: "Unique Plays",
  speedTestingHowToInterpret: "How to interpret?",
  speedTestingChampionSpeed: "🏆 Champion Speed",
  speedTestingFinalizeTest: "Finalize Test",
  speedTestingApply: "Apply",
  speedTestingCancel: "Cancel",
  speedTestingFilterByDate: "Filter by date range",
  speedTestingLastSevenDays: "7 days",
  speedTestingLastThirtyDays: "30 days",
  speedTestingLastNinetyDays: "90 days",
  speedTestingSelectDateRange: "Select a date range",
  speedTestingInfoModal: "How to interpret speed tests",
  speedTestingInfoModalDesc: "Speed tests allow you to compare different configurations to find the best one for your audience.",
  speedTestingMetricsExplanation: "Metrics explanation",
  speedTestingTipsTitle: "Tips for ideal testing",
  speedTestingWarningsTitle: "Important warnings",
  speedTestingEngagementExplanation: "Measure of how long users watch the video relative to the total duration.",
  speedTestingPlayRateExplanation: "Percentage of viewers who start playing the video.",
  speedTestingClicksExplanation: "Number of clicks on the interactive elements of the video.",
  speedTestingManualConfig: "Manual Configuration",
  speedTestingAutomaticTest: "Automatic Test",
  speedTestingMetrics: "Test Metrics",
  speedTestingEnableCustomSpeed: "Enable custom speed",
  speedTestingSpeedMultiplier: "Speed Multiplier",
  speedTestingEnableSpeedTest: "Enable speed test",
  speedTestingInitialSpeed: "Initial speed",
  speedTestingFinalSpeed: "Final speed",
  speedTestingMinDuration: "Minimum test duration",
  speedTestingVictoryCriteria: "Victory criteria",
  speedTestingKeepCurrentEmbed: "Keep current embed",
  speedTestingApplyWinner: "Apply as Winner",
  speedTestingRealTimeUpdate: "Real-time update",
  speedTestingOptionalChart: "Optional chart",
  speedTestingTestDuration: "Test duration",
  speedTestingVictoryCriteriaPlayRate: "Play Rate",
  speedTestingVictoryCriteriaClicks: "Button Clicks",
  speedTestingVictoryCriteriaViews: "Views",
  speedTestingVictoryCriteriaEngagement: "Engagement",
  speedTestingVictoryCriteriaConversions: "Conversions",
  speedTestingDays: "days",
  speedHeaderTitle: "Playback Speed",
  speedHeaderSubtitle: "Configure manually or run automatic A/B tests to optimize engagement.",
  speedManualSectionTitle: "Manual Speed Configuration",
  speedManualDesc: "Manually choose the desired speed for your video. Ideal for direct testing and full control.",
  speedManualEnableTooltip: "Disabled while Automatic Test is active.",
  speedManualSliderLabel: "Select your video's desired speed",
  speedPreviewTitle: "Real-Time Preview",
  speedPreviewCurrent: "Current speed:",
  speedPreviewNote: "Normal playback speed.",
  speedAutoSectionTitle: "Automatic Test with Multiple Speeds",
  speedAutoDesc: "Configure automatic A/B tests with different speeds to optimize your audience engagement.",
  speedAutoEnable: "Enable automatic test with multiple speeds",
  speedAutoInitial: "Initial speed",
  speedAutoFinal: "Final speed",
  speedAutoDuration: "Minimum test duration",
  speedAutoDurationDays: "days of testing",
  speedAutoRange: "Speed range",
  speedAutoStatus: "Status",
  speedAutoStatusRunning: "Running",
  speedAutoStatusPaused: "Paused",
  speedAutoStatusDone: "Completed",
  speedAutoFinish: "Finish Test",
  speedMetricsSubtabMetrics: "Metrics",
  speedMetricsSubtabRetention: "Retention",
  speedMetricsTip: "Tip: Configure a test in the 'Automatic' tab to view comparative metrics by speed.",
  speedMetricsTraffic: "Traffic",
  speedMetricsViews: "Views",
  speedMetricsUniqueViews: "Unique Views",
  speedMetricsPlays: "Plays",
  speedMetricsUniquePlays: "Unique Plays",
  speedMetricsPlayrate: "Playrate",
  speedMetricsEngagement: "Engagement",
  speedMetricsPitch: "Pitch",
  speedMetricsClicks: "Clicks",
  speedMetricsConversions: "Conversions",
  speedMetricsConversionRate: "Conversion",
  speedMetricsRevenue: "Revenue"
};
